var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className,staticStyle:{"width":"100%","max-width":"100vw"},attrs:{"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }